<template>
    <div style="min-height: 60vh;" class="card d-flex">
        <simplebar class="card-body" style="max-height: 60vh">
            <ul v-if="tree_data.length > 0" id="metismenu" class="mm-collapse metismenu">
                <li v-for="item1 in tree_data" :key="'lvl1'+item1.id" :class="isActiveItem(item1.id)" class="has-arrow">
                    <a :id="'level'+item1.id" @contextmenu.prevent="clicker($event, item1.id)" @click="clickLevel(item1)">
                        <i v-if="item1.is_folder" class="fas fa-folder me-2"></i>
                        {{item1.name}}
                    </a>
                    <ul class="mm-collapse">
                            <li v-for="item2 in item1.nodes" :key="'lvl2'+item2.id" class="has-arrow">
                                <a :id="'level'+item2.id" @contextmenu.prevent="clicker($event, item2.id)" @click="clickLevel(item2)">
                                    <i v-if="item2.is_folder" class="fas fa-folder me-2"></i>
                                    {{item2.name}} {{item2.id}}
                                </a>
                                <ul class="mm-collapse">
                                    <div v-if="item2.nodes">
                                        <li v-for="item3 in item2.nodes" :key="'lvl3'+item3.id" class="has-arrow">
                                            <a :id="'level'+item3.id" @contextmenu.prevent="clicker($event, item3.id)" @click="clickLevel(item3)">
                                                <i v-if="item3.is_folder" class="fas fa-folder me-2"></i>
                                                {{item3.name}}
                                            </a>
                                            <ul class="mm-collapse">
                                                <div v-if="item3.nodes"></div>
                                                <!--<div v-else>
                                                    <li>
                                                        <b-button size="sm" variant="outline-primary" @click="showAddDialog">Add Sop</b-button>
                                                    </li>
                                                </div>-->
                                                <div v-if="selected_sop_group == item3.id">
                                                    <li v-for="(sop, idx) in loaded_sops" :key="'document'+idx">
                                                        <a href="#/" @dblclick="fileDoubleClick(sop.id)">
                                                            <i class="far fa-file-alt"></i>
                                                            &nbsp;
                                                            {{sop.name}}
                                                        </a>
                                                    </li>
                                                </div>
                                            </ul>
                                        </li>
                                    </div>
                                    <!--<div v-else>
                                        <li>
                                            <b-button size="sm" variant="outline-primary" @click="showAddDialog">Add Sop</b-button>
                                        </li>
                                    </div>-->
                                    <div v-if="selected_sop_group == item2.id">
                                        <li v-for="(sop, idx) in loaded_sops" :key="'document'+idx">
                                            <a href="" @dblclick="fileDoubleClick(sop.id)">
                                                <i class="far fa-file-alt"></i>
                                                &nbsp;
                                                {{sop.name}}
                                            </a>
                                        </li>
                                    </div>
                                </ul>
                            </li>
                            <li v-for="(sop, idx) in loaded_sops" :key="'document'+idx">
                                <a href="#/" @click="fileDoubleClick(sop.id)">
                                    <i class="far fa-file-alt"></i>
                                    &nbsp;
                                    {{sop.name}}
                                </a>
                            </li>
                            <li v-if="is_loading">
                                <a href="">
                                    <i class="fas fa-spinner fa-spin"></i> Loading Documents
                                </a>
                            </li>
                            <li v-else-if="is_loading == false && loaded_sops.length == 0"><a href="">No Documents</a></li>
                    </ul>
                </li>
            </ul>
            <!-- Old Tree
            <div style="" v-if="tree_data.length > 0">
                <div @contextmenu.prevent="clicker($event, tree_data[0].id)" @click="clickLevel(tree_data[0])" :style="isLevelSelected" class="menu--style" style="margin-left: 5px;">{{tree_data[0].name}}</div>
                <b-collapse v-model="expanded">
                    <div v-for="child of tree_data[0].nodes" :key="child.id">
                        <MenuItem @rightClick="handleRightClick" :depth="depth" :node="child" />
                    </div>
                </b-collapse>
                
            </div>
            -->
        </simplebar>
        
        <div style="border-top: 1px solid grey;" class="p-2">
            <b-button @click="newGroup('parent', null)" variant="outline-primary">
                <i class="fas fa-plus"></i>
                New Parent
            </b-button>
        </div>

        <!--
        //* Extra Components
        -->
        <div style="z-index: 99; position: relative;" @blur="hidePopper" tabindex="-1" @click="hidePopper" ref="contextTreePopper" id="treePopper" v-show="showPopper">
            <ContextMenu :item_id="right_click_item_id" @action="actionHandler" @close="hidePopper"/>
        </div>
        
        <b-overlay :show="is_saving_level">
        <b-modal v-if="show_modal" hide-footer id="groupModal" title="Group">
                <b-row>
                    <b-col cols="6" class="mb-3">
                        <label for="1">
                            Name:
                        </label>
                        <b-form-input v-model="modal_data.name"></b-form-input>
                    </b-col>
                    <b-col cols="6">
                        <label for="1">
                            Prefix:
                        </label>
                        <b-form-input v-model="modal_data.prefix"></b-form-input>
                    </b-col>
                </b-row>
                <div class="w-100 mt-2 mb-2" >
                    <b-button style="float: right;" variant="success" @click="save">Save</b-button>
                    <b-button class="me-2" style="float: right;" @click="$bvModal.hide('groupModal')">Cancel</b-button>
                </div>
        </b-modal>
        </b-overlay>
    </div>
</template>

<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import simplebar from "simplebar-vue";
import { createPopper } from '@popperjs/core';
import { sopAdminMethods, sopAdminState, layoutComputed } from '@/state/helpers.js'
import _ from 'lodash';
//import MenuItem from '@/components/widgets/misc/collapse-menu.vue'
import ContextMenu from './tree-context-menu.vue'
export default {
    data:() => ({
        has_mounted: false,
        is_loading: false,
        rightClickMenu: null,
        right_click_item_id: null,
        showPopper: false,

        tree_data:[],
        expanded: true,
        depth: 1,
        menuRef: null,

        isnew_group:false,
        show_modal: false,
        is_saving_level: false,
        modal_data:{
            id: -1,
            parent_id: null,
            name: '',
            prefix:'',
        }
    }),
    components:{
        //MenuItem,
        ContextMenu,
        //eslint-disable-next-line
        simplebar
    },
    computed:{
        ...layoutComputed,
        ...sopAdminState,
        isLevelSelected(){
            //* Style the current selected level menu node
            var style = '';
            //if(this.returnLevels.length > 0 && this.selected_level != null){
                //if(this.returnLevels[0].id == this.selected_level.id){
                    style = 'text-decoration: underline !important; font-weight: bold;'
                //}
            //}
            return style;
        },
        tree_levels(){
            let data = [];
            if(this.sop_groups != null){
                data = this.sop_groups;
            }
            return data;
        },
        loaded_sops(){
            let data = [];
            if(this.sops != null){
                data = _.cloneDeep(this.sops.sop_types);
            }
            return data;
        }
    },
    methods:{
        ...sopAdminMethods,
        fileDoubleClick(id){
            this.$eventHub.$emit('openDocument', id);
        },
        showAddDialog(){
            //* tell documentList component to show add sop dialog
            this.$eventHub.$emit('addNewSop');
        },
        processLevels(levels){
            var data = _.cloneDeep(levels);
            data.forEach( element => {
                //TODO - Show list of documents for selected level
                if(this.selected_level != null){
                    if(this.selected_level.id == element.id){
                        element['selected'] = true;
                    }
                }
                element['parent'] = element.parent_id;
                element['text'] = element.name;
                element['is_folder'] = true;
            })
            
            data.forEach(ele => {
                let parent_id = ele.parent_id;
                if (parent_id == null) {
                //* Parent item -- do nothing
                }
                else {
                    //* If element is a child element, push to children array.
                    data.forEach(d => {
                        if (d.id === parent_id) {
                            let childArray = d.nodes;
                            if (!childArray) {
                                childArray = []
                            }
                            childArray.push(ele);
                            d.nodes = childArray;
                        }
                    })
                }
            });
            //* Remove duplicate elements
            data = data.filter(ele => ele.parent_id == null);
            if(data.length > 0){
                //*Set parent root as expanded;
                data[0]['opened'] = true;
            }

            return data;
        },
        clickLevel(payload){
            if(this.selected_sop_group != payload.id){
                this.is_loading = true;
                this.selectSopGroup(payload.id)
                .then(()=>{
                    this.loadSops(this.selected_sop_group)
                    .then(()=>{
                        this.is_loading = false;
                    })
                })
            }
        },

        newGroup(type, id){ //* id == the id of the right clicked element
            if(type === 'parent'){
                //* find element to get the parent_id
                let item = _.find(this.sop_groups, {id:id});
                if(item != undefined){
                    this.modal_data.parent_id = item.parent_id;
                }
            }
            else{
                this.modal_data.parent_id = id;
            }

            this.modal_data.name = '';
            this.modal_data.prefix = '';
            
            this.showModal();
        },
        editGroup(id){
            let group = _.find(this.sop_groups, {id: id});
            if(group != undefined){
                this.modal_data.id = group.id;
                this.modal_data.name = group.name;
                this.modal_data.prefix = group.prefix;
            }
            this.showModal();
        },
        save(){
            this.is_saving_level = true;
            this.saveSopGroup(this.modal_data)
            .then(()=>{
                this.loadSopGroups()
                .then(()=>{
                    this.is_saving_level = false;
                    this.tree_data = this.processLevels(this.tree_levels);
                    this.$bvModal.hide('groupModal');
                })
                .catch(()=>{ this.is_saving_level = false; })
            }).catch(()=>{ this.is_saving_level = false; })
        },

        showModal(){
            this.show_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('groupModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'groupModal'){
                        this.show_modal = false;
                        //* Clear form inputs
                        this.modal_data.name = '';
                        this.modal_data.prefix = '';
                    }
                })
            })
        },


        handleRightClick(payload){
            this.clicker(payload.event, payload.id);
        },
        //* popper stuff */
        clicker(event, id){
            //*set id to be used while saving
            this.right_click_item_id = id;

            this.hidePopper();

            this.$nextTick(()=>{
                this.showPopper = true;
                this.$nextTick(()=>{
                    //* Get ref to item element and popper elem
                    const element = document.querySelector('#level'+id)
                    const popper = document.querySelector('#treePopper')
                    this.$nextTick(()=>{
                        this.rightClickMenu = createPopper(element, popper,{
                            placement: 'bottom'
                        });
                        setTimeout(()=>{
                            //* Set focus to the popper element to make sure the blur even is fired
                            if(this.$refs.contextTreePopper != undefined){
                                this.$refs.contextTreePopper.focus();
                            }
                        }, 250);
                    });
                })
            })
        },
        hidePopper(){
            /*if(this.rightClickMenu != null){
                this.rightClickMenu.destroy();
            }*/
            this.showPopper = false;
        },
        actionHandler(type){
            if(type === 'add_child'){
                this.newGroup('child', this.right_click_item_id);
            }
            else if(type === 'add_parent'){
                this.newGroup('parent', this.right_click_item_id);
            }
            else if(type === 'edit'){
                this.editGroup(this.right_click_item_id);
            }
            else if(type === 'delete'){
                let params = { id: this.right_click_item_id };
                this.deleteSopGroup(params)
                .then(()=>{
                    this.loadSopGroups()
                    .then(()=>{
                        this.tree_data = this.processLevels(this.tree_levels);
                        //this.$bvModal.hide('groupsModal');
                    })
                })
            }
        },
        isActiveItem(id){
            if(this.selected_sop_group == id && this.has_mounted == false){
                return 'mm-active'
            }
            else{
                return '';
            }
        }
    },
    mounted(){
        if(this.menu_type === 'documents'){
            if(this.sop_groups == null){
                this.loadSopGroups()
                .then(()=>{
                    this.tree_data = this.processLevels(this.tree_levels);
                    this.$nextTick(()=>{
                        this.menuRef = new MetisMenu("#metismenu", {toggle:true});
                        this.has_mounted = true;
                    })
                })
            }
            else{
                this.tree_data = this.processLevels(this.tree_levels);
                this.$nextTick(()=>{
                    let elem = document.getElementById('metismenu');
                    if(elem != null){
                        this.menuRef = new MetisMenu("#metismenu", {toggle:true});
                        this.has_mounted = true;
                        console.log('Menu Ref',this.menuRef);
                    }
                    //this.menuRef = new MetisMenu("#metismenu", {toggle:false})
                })
            }
        }
        this.$eventHub.$on('clickedLevelItem', this.clickLevel);
    },
    beforeDestroy(){
        if(this.menuRef != null){
            this.menuRef.dispose();
        }
        this.$eventHub.$off('clickedLevelItem');
        //this.$eventHub.$off('setMenuItemData');
    }
}
</script>

<style scoped>
.metismenu {
  padding-left: 0;
}
.metismenu, .metismenu ul {
  list-style: none;
}
.metismenu li {
  position: relative;
}
.metismenu li a {
  display: block;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #333;
  text-decoration: none;
  outline: 0 none;
}
.metismenu ul:before {
  position: absolute;
  border-left: 1px dotted #333;
  content: "";
  width: 30px;
  top: 25px;
  left: 5px;
  bottom: 17px;
}
.metismenu ul > li:before {
  position: absolute;
  border-top: 1px dotted #333;
  content: "";
  width: 30px;
  top: 13px;
  left: -26px;
}
li.active > a > span.fa-folder-o:before {
  content: "\f115" !important;
}




.dropIcon{
    
}


</style>